/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../app/app.module';
import * as import2 from 'ng2-validation/dist/index';
import * as import3 from '@angular/common';
import * as import4 from 'ng2-file-upload/file-upload/file-upload.module';
import * as import5 from '@angular/material';
import * as import6 from '@angular/router';
import * as import7 from '@angular/platform-browser';
import * as import8 from '../../app/ui/mobile-footer/mobile-footer.module';
import * as import9 from '@angular/forms';
import * as import10 from '@angular/platform-browser/animations';
import * as import11 from 'ngx-pagination';
import * as import12 from '@angular/http';
import * as import13 from 'angular2-notifications/src/simple-notifications.module';
import * as import14 from 'md2/accordion/accordion';
import * as import15 from 'md2/autocomplete/autocomplete';
import * as import16 from 'md2/chips/chips';
import * as import17 from 'md2/collapse/collapse';
import * as import18 from 'md2/core/portal/portal-directives';
import * as import19 from 'md2/core/overlay/overlay-directives';
import * as import20 from 'md2/colorpicker/colorpicker';
import * as import21 from 'md2/core/selection/index';
import * as import22 from 'md2/select/option';
import * as import23 from 'md2/core/compatibility/compatibility';
import * as import24 from 'md2/select/index';
import * as import25 from 'md2/data-table/data-table';
import * as import26 from 'md2/datepicker/datepicker';
import * as import27 from 'md2/dialog/dialog';
import * as import28 from 'md2/menu/menu';
import * as import29 from 'md2/core/ripple/index';
import * as import30 from 'md2/tabs/tabs';
import * as import31 from 'md2/tags/tags';
import * as import32 from 'md2/toast/toast';
import * as import33 from 'md2/core/platform/index';
import * as import34 from 'md2/tooltip/index';
import * as import35 from 'md2/core/rtl/dir';
import * as import36 from 'md2/core/observe-content/observe-content';
import * as import37 from 'md2/core/a11y/index';
import * as import38 from 'md2/core/style/index';
import * as import39 from 'md2/module';
import * as import40 from 'ngx-perfect-scrollbar/dist/lib/perfect-scrollbar.module';
import * as import41 from 'ap-angular2-fullcalendar/angular2-fullcalendar';
import * as import42 from 'primeng/components/button/button';
import * as import43 from 'primeng/components/common/shared';
import * as import44 from 'primeng/components/calendar/calendar';
import * as import45 from '@agm/core/core.module';
import * as import46 from 'primeng/components/inputtext/inputtext';
import * as import47 from 'primeng/components/autocomplete/autocomplete';
import * as import48 from 'angular2-multiselect-dropdown/multiselect.component';
import * as import49 from '../../app/shared/pipe/pipe.module';
import * as import50 from '../../app/shared/ui/address/address.module';
import * as import51 from '../../app/shared/ui/billing-account/billing-account.module';
import * as import52 from '../../app/shared/ui/ind-client/ind-client.module';
import * as import53 from '../../app/shared/ui/interpreter/interpreter.module';
import * as import54 from '../../app/shared/ui/interpreter-box/interpreter-box.module';
import * as import55 from '../../app/shared/ui/mobile-header/mobile-header.module';
import * as import56 from '../../app/shared/ui/org-rep/org-rep.module';
import * as import57 from '../../app/shared/ui/termandcondition/termandcondition.module';
import * as import58 from '../../app/shared/shared.module';
import * as import59 from '../../app/shared/validators/index';
import * as import60 from '../../app/shared/modal/modal.module';
import * as import61 from '../../app/auth/login/login.module';
import * as import62 from '../../app/auth/register/pre/pre.module';
import * as import63 from '../../app/auth/register/register.module';
import * as import64 from '../../app/auth/reset/reset.module';
import * as import65 from '../../app/auth/verify/verify.module';
import * as import66 from '../../app/user-management/user-password/user-password-form/user-password-form.module';
import * as import67 from '../../app/auth/update-password/update-password.module';
import * as import68 from '../../app/auth/auth.module';
import * as import69 from '../../app/booking-management/booking-header/booking-header.module';
import * as import70 from '../../app/booking-management/booking-form/add-interpreters/add-interpreters.module';
import * as import71 from '../../app/booking-management/booking-form/booking-form.module';
import * as import72 from '../../app/screen-guard/screen-guard.module';
import * as import73 from 'md2/core/overlay/position/overlay-position-builder';
import * as import74 from 'md2/core/overlay/overlay';
import * as import75 from 'md2/colorpicker/color-util';
import * as import76 from 'md2/datepicker/date-locale';
import * as import77 from 'md2/datepicker/date-util';
import * as import78 from 'md2/core/platform/platform';
import * as import79 from 'md2/core/a11y/interactivity-checker';
import * as import80 from 'md2/core/a11y/focus-trap';
import * as import81 from '../../app/auth/auth-token.guard';
import * as import82 from 'angular2-notifications/src/notifications.service';
import * as import83 from '@agm/core/utils/browser-globals';
import * as import84 from '@agm/core/services/maps-api-loader/lazy-maps-api-loader';
import * as import85 from '../../app/shared/role-permission/role-permission';
import * as import86 from '../../app/shared/router/linkhelper';
import * as import87 from '../../app/shared/user-name.service';
import * as import88 from '../../app/auth/auth.guard';
import * as import89 from '../../app/auth/verified.guard';
import * as import90 from '../../app/auth/no-auth.guard';
import * as import91 from '../../app/notification/notification.service';
import * as import92 from '../../app/spinner/spinner.service';
import * as import93 from '../../app/shared/popup/popup.service';
import * as import94 from '../../app/api/booking.service';
import * as import95 from '../../app/api/user.service';
import * as import96 from '../../app/shared/prefered-allocation.service';
import * as import97 from '../../app/booking-management/booking-header/booking-header.service';
import * as import98 from '../../app/api/gmaps-api.service';
import * as import99 from '../../app/api/messaging.service';
import * as import100 from '../../app/booking-management/booking-list/booking-list-multi-select.service';
import * as import101 from '../../app/shared/sub-organisation-filter/sub-organisation-filter.service';
import * as import102 from '../../$$_gendir/node_modules/md2/toast/toast.ngfactory';
import * as import103 from '../../$$_gendir/node_modules/md2/tooltip/tooltip.ngfactory';
import * as import104 from '../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as import105 from './auth/login/login.component.ngfactory';
import * as import106 from './auth/register/pre/pre.component.ngfactory';
import * as import107 from './auth/register/register.component.ngfactory';
import * as import108 from './auth/reset/reset.component.ngfactory';
import * as import109 from './auth/verify/verify.component.ngfactory';
import * as import110 from './auth/update-password/update-password.component.ngfactory';
import * as import111 from './user-management/user-management.component.ngfactory';
import * as import112 from './user-management/user-profile/user-profile.component.ngfactory';
import * as import113 from './user-management/user-password/user-password.component.ngfactory';
import * as import114 from './user-management/skill-matrix/skill-matrix.component.ngfactory';
import * as import115 from './user-management/user-profile/blockout/blockout.component.ngfactory';
import * as import116 from './user-management/staff-calendar/staff-calendar.component.ngfactory';
import * as import117 from './user-management/user-payroll-billing/user-payroll-billing.component.ngfactory';
import * as import118 from './booking-management/booking.component.ngfactory';
import * as import119 from './booking-management/booking-detail/booking-detail.component.ngfactory';
import * as import120 from './booking-management/booking-form/booking-form.component.ngfactory';
import * as import121 from './booking-management/booking-jobs/booking-jobs.component.ngfactory';
import * as import122 from './booking-management/booking-payroll/booking-payroll.component.ngfactory';
import * as import123 from './messaging/inbox/inbox.component.ngfactory';
import * as import124 from './reports/reports.component.ngfactory';
import * as import125 from './not-found/not-found.component.ngfactory';
import * as import126 from './dashboard/dashboard.component.ngfactory';
import * as import127 from './shared/popup/popup.component.ngfactory';
import * as import128 from './shared/ui/interpreter-popup/interpreter-popup.component.ngfactory';
import * as import129 from './booking-management/linkid-popup/linkid-popup.component.ngfactory';
import * as import130 from './app.component.ngfactory';
import * as import131 from 'md2/core/overlay/overlay-container';
import * as import132 from 'md2/core/overlay/scroll/scroll-dispatcher';
import * as import133 from 'md2/core/overlay/position/viewport-ruler';
import * as import134 from 'md2/core/a11y/live-announcer';
import * as import135 from 'md2/core/style/focus-origin-monitor';
import * as import136 from '../../app/shared/global';
import * as import137 from '../../app/auth/login/login.component';
import * as import138 from '../../app/auth/register/pre/pre.component';
import * as import139 from '../../app/auth/register/register.component';
import * as import140 from '../../app/auth/reset/reset.component';
import * as import141 from '../../app/auth/verify/verify.component';
import * as import142 from '../../app/auth/update-password/update-password.component';
import * as import143 from '../../app/user-management/user-management.component';
import * as import144 from '../../app/user-management/user-profile/user-profile.component';
import * as import145 from '../../app/user-management/user-password/user-password.component';
import * as import146 from '../../app/user-management/skill-matrix/skill-matrix.component';
import * as import147 from '../../app/user-management/user-profile/blockout/blockout.component';
import * as import148 from '../../app/user-management/staff-calendar/staff-calendar.component';
import * as import149 from '../../app/user-management/user-payroll-billing/user-payroll-billing.component';
import * as import150 from '../../app/booking-management/booking.component';
import * as import151 from '../../app/booking-management/booking-detail/booking-detail.component';
import * as import152 from '../../app/booking-management/booking-form/booking-form.component';
import * as import153 from '../../app/booking-management/booking-jobs/booking-jobs.component';
import * as import154 from '../../app/booking-management/booking-payroll/booking-payroll.component';
import * as import155 from '../../app/messaging/inbox/inbox.component';
import * as import156 from '../../app/reports/reports.component';
import * as import157 from '../../app/not-found/not-found.component';
import * as import158 from '../../app/dashboard/dashboard.component';
import * as import159 from 'ngx-perfect-scrollbar/dist/lib/perfect-scrollbar.interfaces';
import * as import160 from '@angular/animations/browser';
import * as import161 from '@agm/core/services/maps-api-loader/maps-api-loader';
import * as import162 from 'angular2-jwt/angular2-jwt';
class AppModuleInjector extends import0.ɵNgModuleInjector<import1.AppModule> {
  _CustomFormsModule_0:import2.CustomFormsModule;
  _CommonModule_1:import3.CommonModule;
  _FileUploadModule_2:import4.FileUploadModule;
  _MATERIAL_SANITY_CHECKS_3:any;
  _CompatibilityModule_4:import5.CompatibilityModule;
  _MdCommonModule_5:import5.MdCommonModule;
  _PlatformModule_6:import5.PlatformModule;
  _ɵm_7:import5.ɵm;
  _MdRippleModule_8:import5.MdRippleModule;
  _MdCheckboxModule_9:import5.MdCheckboxModule;
  _ErrorHandler_10:any;
  _NgProbeToken_11:any[];
  _ɵg_12:import6.ɵg;
  _APP_INITIALIZER_13:any[];
  _ApplicationInitStatus_14:import0.ApplicationInitStatus;
  _ɵf_15:import0.ɵf;
  _ApplicationRef_16:any;
  _ApplicationModule_17:import0.ApplicationModule;
  _BrowserModule_18:import7.BrowserModule;
  _ɵa_19:any;
  _UrlSerializer_20:import6.DefaultUrlSerializer;
  _RouterOutletMap_21:import6.RouterOutletMap;
  _APP_BASE_HREF_22:any;
  _LocationStrategy_23:import3.HashLocationStrategy;
  _Location_24:import3.Location;
  _Compiler_25:import0.Compiler;
  _NgModuleFactoryLoader_26:import0.SystemJsNgModuleLoader;
  _ROUTES_27:any[];
  _ROUTER_CONFIGURATION_28:any;
  _Router_29:any;
  _RouterModule_30:import6.RouterModule;
  _MobileFooterModule_31:import8.MobileFooterModule;
  _ɵba_32:import9.ɵba;
  _FormsModule_33:import9.FormsModule;
  _BrowserAnimationsModule_34:import10.BrowserAnimationsModule;
  _NgxPaginationModule_35:import11.NgxPaginationModule;
  _HttpModule_36:import12.HttpModule;
  _SimpleNotificationsModule_37:import13.SimpleNotificationsModule;
  _ReactiveFormsModule_38:import9.ReactiveFormsModule;
  _Md2AccordionModule_39:import14.Md2AccordionModule;
  _Md2AutocompleteModule_40:import15.Md2AutocompleteModule;
  _Md2ChipsModule_41:import16.Md2ChipsModule;
  _Md2CollapseModule_42:import17.Md2CollapseModule;
  _PortalModule_43:import18.PortalModule;
  _OverlayModule_44:import19.OverlayModule;
  _Md2ColorpickerModule_45:import20.Md2ColorpickerModule;
  _MdSelectionModule_46:import21.MdSelectionModule;
  _Md2OptionModule_47:import22.Md2OptionModule;
  _CompatibilityModule_48:import23.CompatibilityModule;
  _Md2SelectModule_49:import24.Md2SelectModule;
  _Md2DataTableModule_50:import25.Md2DataTableModule;
  _Md2DatepickerModule_51:import26.Md2DatepickerModule;
  _Md2DialogModule_52:import27.Md2DialogModule;
  _Md2MenuModule_53:import28.Md2MenuModule;
  _MdRippleModule_54:import29.MdRippleModule;
  _Md2TabsModule_55:import30.Md2TabsModule;
  _Md2TagsModule_56:import31.Md2TagsModule;
  _Md2ToastModule_57:import32.Md2ToastModule;
  _PlatformModule_58:import33.PlatformModule;
  _Md2TooltipModule_59:import34.Md2TooltipModule;
  _RtlModule_60:import35.RtlModule;
  _ObserveContentModule_61:import36.ObserveContentModule;
  _A11yModule_62:import37.A11yModule;
  _StyleModule_63:import38.StyleModule;
  _Md2RootModule_64:import39.Md2RootModule;
  _PERFECT_SCROLLBAR_GUARD_65:any;
  _PerfectScrollbarModule_66:import40.PerfectScrollbarModule;
  _MdSelectionModule_67:import5.MdSelectionModule;
  _MdOptionModule_68:import5.MdOptionModule;
  _PortalModule_69:import5.PortalModule;
  _OverlayModule_70:import5.OverlayModule;
  _MdAutocompleteModule_71:import5.MdAutocompleteModule;
  _StyleModule_72:import5.StyleModule;
  _MdButtonModule_73:import5.MdButtonModule;
  _MdButtonToggleModule_74:import5.MdButtonToggleModule;
  _MdCardModule_75:import5.MdCardModule;
  _MdChipsModule_76:import5.MdChipsModule;
  _A11yModule_77:import5.A11yModule;
  _MdDialogModule_78:import5.MdDialogModule;
  _MdDatepickerModule_79:import5.MdDatepickerModule;
  _MdLineModule_80:import5.MdLineModule;
  _MdGridListModule_81:import5.MdGridListModule;
  _MdIconModule_82:import5.MdIconModule;
  _MdInputModule_83:import5.MdInputModule;
  _MdListModule_84:import5.MdListModule;
  _MdMenuModule_85:import5.MdMenuModule;
  _MdProgressBarModule_86:import5.MdProgressBarModule;
  _MdProgressSpinnerModule_87:import5.MdProgressSpinnerModule;
  _MdRadioModule_88:import5.MdRadioModule;
  _MdSelectModule_89:import5.MdSelectModule;
  _MdSidenavModule_90:import5.MdSidenavModule;
  _RtlModule_91:import5.RtlModule;
  _MdSliderModule_92:import5.MdSliderModule;
  _MdSlideToggleModule_93:import5.MdSlideToggleModule;
  _MdSnackBarModule_94:import5.MdSnackBarModule;
  _ObserveContentModule_95:import5.ObserveContentModule;
  _MdTabsModule_96:import5.MdTabsModule;
  _MdToolbarModule_97:import5.MdToolbarModule;
  _MdTooltipModule_98:import5.MdTooltipModule;
  _MaterialModule_99:import5.MaterialModule;
  _CalendarModule_100:import41.CalendarModule;
  _ButtonModule_101:import42.ButtonModule;
  _SharedModule_102:import43.SharedModule;
  _CalendarModule_103:import44.CalendarModule;
  _AgmCoreModule_104:import45.AgmCoreModule;
  _InputTextModule_105:import46.InputTextModule;
  _AutoCompleteModule_106:import47.AutoCompleteModule;
  _AngularMultiSelectModule_107:import48.AngularMultiSelectModule;
  _PipeModule_108:import49.PipeModule;
  _AddressModule_109:import50.AddressModule;
  _BillingAccountModule_110:import51.BillingAccountModule;
  _IndClientModule_111:import52.IndClientModule;
  _InterpreterModule_112:import53.InterpreterModule;
  _InterpreterBoxModule_113:import54.InterpreterBoxModule;
  _MobileHeaderModule_114:import55.MobileHeaderModule;
  _OrgRepModule_115:import56.OrgRepModule;
  _TermandconditionModule_116:import57.TermandconditionModule;
  _SharedModule_117:import58.SharedModule;
  _PasswordValidatorModule_118:import59.PasswordValidatorModule;
  _ModalModule_119:import60.ModalModule;
  _LoginModule_120:import61.LoginModule;
  _PreModule_121:import62.PreModule;
  _RegisterModule_122:import63.RegisterModule;
  _ResetModule_123:import64.ResetModule;
  _VerifyModule_124:import65.VerifyModule;
  _UserPasswordFormModule_125:import66.UserPasswordFormModule;
  _UpdatePasswordModule_126:import67.UpdatePasswordModule;
  _AuthModule_127:import68.AuthModule;
  _BookingHeaderModule_128:import69.BookingHeaderModule;
  _AddInterpretersModule_129:import70.AddInterpretersModule;
  _BookingFormModule_130:import71.BookingFormModule;
  _ScreenGuardModule_131:import72.ScreenGuardModule;
  _AppModule_132:import1.AppModule;
  __LOCALE_ID_133:any;
  __NgLocalization_134:import3.NgLocaleLocalization;
  __Platform_135:import5.Platform;
  __ScrollDispatcher_136:any;
  __ɵo_137:any;
  __FocusOriginMonitor_138:any;
  __APP_ID_139:any;
  __IterableDiffers_140:any;
  __KeyValueDiffers_141:any;
  __DomSanitizer_142:import7.ɵe;
  __Sanitizer_143:any;
  __HAMMER_GESTURE_CONFIG_144:import5.GestureConfig;
  __EVENT_MANAGER_PLUGINS_145:any[];
  __EventManager_146:import7.EventManager;
  __ɵDomSharedStylesHost_147:import7.ɵDomSharedStylesHost;
  __ɵDomRendererFactory2_148:import7.ɵDomRendererFactory2;
  __AnimationDriver_149:any;
  __ɵAnimationStyleNormalizer_150:any;
  __ɵAnimationEngine_151:import10.ɵa;
  __RendererFactory2_152:any;
  __ɵSharedStylesHost_153:any;
  __Testability_154:import0.Testability;
  __Meta_155:import7.Meta;
  __Title_156:import7.Title;
  __ɵi_157:import9.ɵi;
  __PaginationService_158:import11.PaginationService;
  __BrowserXhr_159:import12.BrowserXhr;
  __ResponseOptions_160:import12.BaseResponseOptions;
  __XSRFStrategy_161:any;
  __XHRBackend_162:import12.XHRBackend;
  __RequestOptions_163:import12.BaseRequestOptions;
  __Http_164:any;
  __FormBuilder_165:import9.FormBuilder;
  __OverlayContainer_166:any;
  __ScrollDispatcher_167:any;
  __ViewportRuler_168:any;
  __OverlayPositionBuilder_169:import73.OverlayPositionBuilder;
  __Overlay_170:import74.Overlay;
  __ColorUtil_171:import75.ColorUtil;
  __DateLocale_172:import76.DateLocale;
  __DateUtil_173:import77.DateUtil;
  __Md2ToastConfig_174:import32.Md2ToastConfig;
  __Md2Toast_175:import32.Md2Toast;
  __Platform_176:import78.Platform;
  __InteractivityChecker_177:import79.InteractivityChecker;
  __FocusTrapFactory_178:import80.FocusTrapFactory;
  __LiveAnnouncer_179:any;
  __FocusOriginMonitor_180:any;
  __OverlayContainer_181:any;
  __ɵr_182:import5.ɵr;
  __Overlay_183:import5.Overlay;
  __UniqueSelectionDispatcher_184:any;
  __InteractivityChecker_185:import5.InteractivityChecker;
  __FocusTrapFactory_186:import5.FocusTrapFactory;
  __LiveAnnouncer_187:any;
  __MdDialog_188:import5.MdDialog;
  __MdDatepickerIntl_189:import5.MdDatepickerIntl;
  __MdIconRegistry_190:any;
  __MdSnackBar_191:import5.MdSnackBar;
  __ɵa_192:import5.ɵa;
  __AuthTokenGuard_193:import81.AuthTokenGuard;
  __NotificationsService_194:import82.NotificationsService;
  _PERFECT_SCROLLBAR_CONFIG_195:any;
  __PerfectScrollbarConfig_196:any;
  __WindowRef_197:import83.WindowRef;
  __DocumentRef_198:import83.DocumentRef;
  _LAZY_MAPS_API_CONFIG_199:any;
  __MapsAPILoader_200:import84.LazyMapsAPILoader;
  __ActivatedRoute_201:any;
  __NoPreloading_202:import6.NoPreloading;
  __PreloadingStrategy_203:any;
  __RouterPreloader_204:import6.RouterPreloader;
  __PreloadAllModules_205:import6.PreloadAllModules;
  __ROUTER_INITIALIZER_206:any;
  __APP_BOOTSTRAP_LISTENER_207:any[];
  __DatePipe_208:import3.DatePipe;
  __RolePermission_209:import85.RolePermission;
  __LinkAuth_210:import86.LinkAuth;
  __UserNameService_211:import87.UserNameService;
  __AuthGuard_212:import88.AuthGuard;
  __VerifiedGuard_213:import89.VerifiedGuard;
  __NoAuthGuard_214:import90.NoAuthGuard;
  __LinkHelper_215:import86.LinkHelper;
  __NotificationServiceBus_216:import91.NotificationServiceBus;
  __SpinnerService_217:import92.SpinnerService;
  __AuthHttp_218:any;
  __PopupService_219:import93.PopupService;
  __BookingService_220:import94.BookingService;
  __UserService_221:import95.UserService;
  __PreferedAllocationService_222:import96.PreferedAllocationService;
  __BookingHeaderService_223:import97.BookingHeaderService;
  __GmapsApiService_224:import98.GmapsApiService;
  __MessagingService_225:import99.MessagingService;
  __BookingListMultiSelectService_226:import100.BookingListMultiSelectService<any,any>;
  __SubOrganisationFilterService_227:import101.SubOrganisationFilterService;
  constructor(parent:import0.Injector) {
    super(parent,[
      import102.Md2ToastComponentNgFactory,
      import103.Md2TooltipComponentNgFactory,
      import104.MdDialogContainerNgFactory,
      import104.MdDatepickerContentNgFactory,
      import104.MdSnackBarContainerNgFactory,
      import104.SimpleSnackBarNgFactory,
      import104.TooltipComponentNgFactory,
      import105.LoginComponentNgFactory,
      import106.PreComponentNgFactory,
      import107.RegisterComponentNgFactory,
      import108.ResetComponentNgFactory,
      import109.VerifyComponentNgFactory,
      import110.UpdatePasswordComponentNgFactory,
      import111.UserManagementComponentNgFactory,
      import112.UserProfileComponentNgFactory,
      import113.UserPasswordComponentNgFactory,
      import114.SkillMatrixComponentNgFactory,
      import115.BlockoutComponentNgFactory,
      import116.StaffCalendarComponentNgFactory,
      import117.UserPayrollBillingComponentNgFactory,
      import118.BookingComponentNgFactory,
      import119.BookingDetailComponentNgFactory,
      import120.BookingFormComponentNgFactory,
      import121.BookingJobsComponentNgFactory,
      import122.BookingPayrollComponentNgFactory,
      import123.InboxComponentNgFactory,
      import124.ReportsComponentNgFactory,
      import125.NotFoundComponentNgFactory,
      import126.DashboardComponentNgFactory,
      import127.PopupComponentNgFactory,
      import128.InterpreterPopupComponentNgFactory,
      import129.LinkidPopupComponentNgFactory,
      import130.AppComponentNgFactory
    ]
    ,[import130.AppComponentNgFactory]);
  }
  get _LOCALE_ID_133():any {
    if ((this.__LOCALE_ID_133 == null)) { (this.__LOCALE_ID_133 = import0.ɵn(this.parent.get(import0.LOCALE_ID,(null as any)))); }
    return this.__LOCALE_ID_133;
  }
  get _NgLocalization_134():import3.NgLocaleLocalization {
    if ((this.__NgLocalization_134 == null)) { (this.__NgLocalization_134 = new import3.NgLocaleLocalization(this._LOCALE_ID_133)); }
    return this.__NgLocalization_134;
  }
  get _Platform_135():import5.Platform {
    if ((this.__Platform_135 == null)) { (this.__Platform_135 = new import5.Platform()); }
    return this.__Platform_135;
  }
  get _ScrollDispatcher_136():any {
    if ((this.__ScrollDispatcher_136 == null)) { (this.__ScrollDispatcher_136 = import5.ɵd(this.parent.get(import5.ScrollDispatcher,(null as any)),this.parent.get(import0.NgZone),this._Platform_135)); }
    return this.__ScrollDispatcher_136;
  }
  get _ɵo_137():any {
    if ((this.__ɵo_137 == null)) { (this.__ɵo_137 = import5.ɵp(this.parent.get(import5.ɵo,(null as any)),this._ScrollDispatcher_136)); }
    return this.__ɵo_137;
  }
  get _FocusOriginMonitor_138():any {
    if ((this.__FocusOriginMonitor_138 == null)) { (this.__FocusOriginMonitor_138 = import5.FOCUS_ORIGIN_MONITOR_PROVIDER_FACTORY(this.parent.get(import5.FocusOriginMonitor,(null as any)),this.parent.get(import0.NgZone),this._Platform_135)); }
    return this.__FocusOriginMonitor_138;
  }
  get _APP_ID_139():any {
    if ((this.__APP_ID_139 == null)) { (this.__APP_ID_139 = import0.ɵg()); }
    return this.__APP_ID_139;
  }
  get _IterableDiffers_140():any {
    if ((this.__IterableDiffers_140 == null)) { (this.__IterableDiffers_140 = import0.ɵl()); }
    return this.__IterableDiffers_140;
  }
  get _KeyValueDiffers_141():any {
    if ((this.__KeyValueDiffers_141 == null)) { (this.__KeyValueDiffers_141 = import0.ɵm()); }
    return this.__KeyValueDiffers_141;
  }
  get _DomSanitizer_142():import7.ɵe {
    if ((this.__DomSanitizer_142 == null)) { (this.__DomSanitizer_142 = new import7.ɵe(this.parent.get(import7.DOCUMENT))); }
    return this.__DomSanitizer_142;
  }
  get _Sanitizer_143():any {
    if ((this.__Sanitizer_143 == null)) { (this.__Sanitizer_143 = this._DomSanitizer_142); }
    return this.__Sanitizer_143;
  }
  get _HAMMER_GESTURE_CONFIG_144():import5.GestureConfig {
    if ((this.__HAMMER_GESTURE_CONFIG_144 == null)) { (this.__HAMMER_GESTURE_CONFIG_144 = new import5.GestureConfig()); }
    return this.__HAMMER_GESTURE_CONFIG_144;
  }
  get _EVENT_MANAGER_PLUGINS_145():any[] {
    if ((this.__EVENT_MANAGER_PLUGINS_145 == null)) { (this.__EVENT_MANAGER_PLUGINS_145 = [
      new import7.ɵDomEventsPlugin(this.parent.get(import7.DOCUMENT)),
      new import7.ɵKeyEventsPlugin(this.parent.get(import7.DOCUMENT)),
      new import7.ɵHammerGesturesPlugin(this.parent.get(import7.DOCUMENT),this._HAMMER_GESTURE_CONFIG_144)
    ]
    ); }
    return this.__EVENT_MANAGER_PLUGINS_145;
  }
  get _EventManager_146():import7.EventManager {
    if ((this.__EventManager_146 == null)) { (this.__EventManager_146 = new import7.EventManager(this._EVENT_MANAGER_PLUGINS_145,this.parent.get(import0.NgZone))); }
    return this.__EventManager_146;
  }
  get _ɵDomSharedStylesHost_147():import7.ɵDomSharedStylesHost {
    if ((this.__ɵDomSharedStylesHost_147 == null)) { (this.__ɵDomSharedStylesHost_147 = new import7.ɵDomSharedStylesHost(this.parent.get(import7.DOCUMENT))); }
    return this.__ɵDomSharedStylesHost_147;
  }
  get _ɵDomRendererFactory2_148():import7.ɵDomRendererFactory2 {
    if ((this.__ɵDomRendererFactory2_148 == null)) { (this.__ɵDomRendererFactory2_148 = new import7.ɵDomRendererFactory2(this._EventManager_146,this._ɵDomSharedStylesHost_147)); }
    return this.__ɵDomRendererFactory2_148;
  }
  get _AnimationDriver_149():any {
    if ((this.__AnimationDriver_149 == null)) { (this.__AnimationDriver_149 = import10.ɵb()); }
    return this.__AnimationDriver_149;
  }
  get _ɵAnimationStyleNormalizer_150():any {
    if ((this.__ɵAnimationStyleNormalizer_150 == null)) { (this.__ɵAnimationStyleNormalizer_150 = import10.ɵc()); }
    return this.__ɵAnimationStyleNormalizer_150;
  }
  get _ɵAnimationEngine_151():import10.ɵa {
    if ((this.__ɵAnimationEngine_151 == null)) { (this.__ɵAnimationEngine_151 = new import10.ɵa(this._AnimationDriver_149,this._ɵAnimationStyleNormalizer_150)); }
    return this.__ɵAnimationEngine_151;
  }
  get _RendererFactory2_152():any {
    if ((this.__RendererFactory2_152 == null)) { (this.__RendererFactory2_152 = import10.ɵd(this._ɵDomRendererFactory2_148,this._ɵAnimationEngine_151,this.parent.get(import0.NgZone))); }
    return this.__RendererFactory2_152;
  }
  get _ɵSharedStylesHost_153():any {
    if ((this.__ɵSharedStylesHost_153 == null)) { (this.__ɵSharedStylesHost_153 = this._ɵDomSharedStylesHost_147); }
    return this.__ɵSharedStylesHost_153;
  }
  get _Testability_154():import0.Testability {
    if ((this.__Testability_154 == null)) { (this.__Testability_154 = new import0.Testability(this.parent.get(import0.NgZone))); }
    return this.__Testability_154;
  }
  get _Meta_155():import7.Meta {
    if ((this.__Meta_155 == null)) { (this.__Meta_155 = new import7.Meta(this.parent.get(import7.DOCUMENT))); }
    return this.__Meta_155;
  }
  get _Title_156():import7.Title {
    if ((this.__Title_156 == null)) { (this.__Title_156 = new import7.Title(this.parent.get(import7.DOCUMENT))); }
    return this.__Title_156;
  }
  get _ɵi_157():import9.ɵi {
    if ((this.__ɵi_157 == null)) { (this.__ɵi_157 = new import9.ɵi()); }
    return this.__ɵi_157;
  }
  get _PaginationService_158():import11.PaginationService {
    if ((this.__PaginationService_158 == null)) { (this.__PaginationService_158 = new import11.PaginationService()); }
    return this.__PaginationService_158;
  }
  get _BrowserXhr_159():import12.BrowserXhr {
    if ((this.__BrowserXhr_159 == null)) { (this.__BrowserXhr_159 = new import12.BrowserXhr()); }
    return this.__BrowserXhr_159;
  }
  get _ResponseOptions_160():import12.BaseResponseOptions {
    if ((this.__ResponseOptions_160 == null)) { (this.__ResponseOptions_160 = new import12.BaseResponseOptions()); }
    return this.__ResponseOptions_160;
  }
  get _XSRFStrategy_161():any {
    if ((this.__XSRFStrategy_161 == null)) { (this.__XSRFStrategy_161 = import12.ɵb()); }
    return this.__XSRFStrategy_161;
  }
  get _XHRBackend_162():import12.XHRBackend {
    if ((this.__XHRBackend_162 == null)) { (this.__XHRBackend_162 = new import12.XHRBackend(this._BrowserXhr_159,this._ResponseOptions_160,this._XSRFStrategy_161)); }
    return this.__XHRBackend_162;
  }
  get _RequestOptions_163():import12.BaseRequestOptions {
    if ((this.__RequestOptions_163 == null)) { (this.__RequestOptions_163 = new import12.BaseRequestOptions()); }
    return this.__RequestOptions_163;
  }
  get _Http_164():any {
    if ((this.__Http_164 == null)) { (this.__Http_164 = import12.ɵc(this._XHRBackend_162,this._RequestOptions_163)); }
    return this.__Http_164;
  }
  get _FormBuilder_165():import9.FormBuilder {
    if ((this.__FormBuilder_165 == null)) { (this.__FormBuilder_165 = new import9.FormBuilder()); }
    return this.__FormBuilder_165;
  }
  get _OverlayContainer_166():any {
    if ((this.__OverlayContainer_166 == null)) { (this.__OverlayContainer_166 = import131.OVERLAY_CONTAINER_PROVIDER_FACTORY(this.parent.get(import131.OverlayContainer,(null as any)))); }
    return this.__OverlayContainer_166;
  }
  get _ScrollDispatcher_167():any {
    if ((this.__ScrollDispatcher_167 == null)) { (this.__ScrollDispatcher_167 = import132.SCROLL_DISPATCHER_PROVIDER_FACTORY(this.parent.get(import132.ScrollDispatcher,(null as any)),this.parent.get(import0.NgZone))); }
    return this.__ScrollDispatcher_167;
  }
  get _ViewportRuler_168():any {
    if ((this.__ViewportRuler_168 == null)) { (this.__ViewportRuler_168 = import133.VIEWPORT_RULER_PROVIDER_FACTORY(this.parent.get(import133.ViewportRuler,(null as any)),this._ScrollDispatcher_167)); }
    return this.__ViewportRuler_168;
  }
  get _OverlayPositionBuilder_169():import73.OverlayPositionBuilder {
    if ((this.__OverlayPositionBuilder_169 == null)) { (this.__OverlayPositionBuilder_169 = new import73.OverlayPositionBuilder(this._ViewportRuler_168)); }
    return this.__OverlayPositionBuilder_169;
  }
  get _Overlay_170():import74.Overlay {
    if ((this.__Overlay_170 == null)) { (this.__Overlay_170 = new import74.Overlay(this._OverlayContainer_166,this.componentFactoryResolver,this._OverlayPositionBuilder_169,this._ApplicationRef_16,this,this.parent.get(import0.NgZone))); }
    return this.__Overlay_170;
  }
  get _ColorUtil_171():import75.ColorUtil {
    if ((this.__ColorUtil_171 == null)) { (this.__ColorUtil_171 = new import75.ColorUtil()); }
    return this.__ColorUtil_171;
  }
  get _DateLocale_172():import76.DateLocale {
    if ((this.__DateLocale_172 == null)) { (this.__DateLocale_172 = new import76.DateLocale()); }
    return this.__DateLocale_172;
  }
  get _DateUtil_173():import77.DateUtil {
    if ((this.__DateUtil_173 == null)) { (this.__DateUtil_173 = new import77.DateUtil()); }
    return this.__DateUtil_173;
  }
  get _Md2ToastConfig_174():import32.Md2ToastConfig {
    if ((this.__Md2ToastConfig_174 == null)) { (this.__Md2ToastConfig_174 = new import32.Md2ToastConfig()); }
    return this.__Md2ToastConfig_174;
  }
  get _Md2Toast_175():import32.Md2Toast {
    if ((this.__Md2Toast_175 == null)) { (this.__Md2Toast_175 = new import32.Md2Toast(this._Overlay_170,this._Md2ToastConfig_174)); }
    return this.__Md2Toast_175;
  }
  get _Platform_176():import78.Platform {
    if ((this.__Platform_176 == null)) { (this.__Platform_176 = new import78.Platform()); }
    return this.__Platform_176;
  }
  get _InteractivityChecker_177():import79.InteractivityChecker {
    if ((this.__InteractivityChecker_177 == null)) { (this.__InteractivityChecker_177 = new import79.InteractivityChecker(this._Platform_176)); }
    return this.__InteractivityChecker_177;
  }
  get _FocusTrapFactory_178():import80.FocusTrapFactory {
    if ((this.__FocusTrapFactory_178 == null)) { (this.__FocusTrapFactory_178 = new import80.FocusTrapFactory(this._InteractivityChecker_177,this.parent.get(import0.NgZone))); }
    return this.__FocusTrapFactory_178;
  }
  get _LiveAnnouncer_179():any {
    if ((this.__LiveAnnouncer_179 == null)) { (this.__LiveAnnouncer_179 = import134.LIVE_ANNOUNCER_PROVIDER_FACTORY(this.parent.get(import134.LiveAnnouncer,(null as any)),this.parent.get(import134.LIVE_ANNOUNCER_ELEMENT_TOKEN,(null as any)))); }
    return this.__LiveAnnouncer_179;
  }
  get _FocusOriginMonitor_180():any {
    if ((this.__FocusOriginMonitor_180 == null)) { (this.__FocusOriginMonitor_180 = import135.FOCUS_ORIGIN_MONITOR_PROVIDER_FACTORY(this.parent.get(import135.FocusOriginMonitor,(null as any)),this.parent.get(import0.NgZone))); }
    return this.__FocusOriginMonitor_180;
  }
  get _OverlayContainer_181():any {
    if ((this.__OverlayContainer_181 == null)) { (this.__OverlayContainer_181 = import5.ɵb(this.parent.get(import5.OverlayContainer,(null as any)))); }
    return this.__OverlayContainer_181;
  }
  get _ɵr_182():import5.ɵr {
    if ((this.__ɵr_182 == null)) { (this.__ɵr_182 = new import5.ɵr(this._ɵo_137)); }
    return this.__ɵr_182;
  }
  get _Overlay_183():import5.Overlay {
    if ((this.__Overlay_183 == null)) { (this.__Overlay_183 = new import5.Overlay(this._OverlayContainer_181,this.componentFactoryResolver,this._ɵr_182,this._ApplicationRef_16,this,this.parent.get(import0.NgZone))); }
    return this.__Overlay_183;
  }
  get _UniqueSelectionDispatcher_184():any {
    if ((this.__UniqueSelectionDispatcher_184 == null)) { (this.__UniqueSelectionDispatcher_184 = import5.ɵh(this.parent.get(import5.UniqueSelectionDispatcher,(null as any)))); }
    return this.__UniqueSelectionDispatcher_184;
  }
  get _InteractivityChecker_185():import5.InteractivityChecker {
    if ((this.__InteractivityChecker_185 == null)) { (this.__InteractivityChecker_185 = new import5.InteractivityChecker(this._Platform_135)); }
    return this.__InteractivityChecker_185;
  }
  get _FocusTrapFactory_186():import5.FocusTrapFactory {
    if ((this.__FocusTrapFactory_186 == null)) { (this.__FocusTrapFactory_186 = new import5.FocusTrapFactory(this._InteractivityChecker_185,this.parent.get(import0.NgZone))); }
    return this.__FocusTrapFactory_186;
  }
  get _LiveAnnouncer_187():any {
    if ((this.__LiveAnnouncer_187 == null)) { (this.__LiveAnnouncer_187 = import5.ɵg(this.parent.get(import5.LiveAnnouncer,(null as any)),this.parent.get(import5.LIVE_ANNOUNCER_ELEMENT_TOKEN,(null as any)),this._Platform_135)); }
    return this.__LiveAnnouncer_187;
  }
  get _MdDialog_188():import5.MdDialog {
    if ((this.__MdDialog_188 == null)) { (this.__MdDialog_188 = new import5.MdDialog(this._Overlay_183,this,this._Location_24,this.parent.get(import5.MdDialog,(null as any)))); }
    return this.__MdDialog_188;
  }
  get _MdDatepickerIntl_189():import5.MdDatepickerIntl {
    if ((this.__MdDatepickerIntl_189 == null)) { (this.__MdDatepickerIntl_189 = new import5.MdDatepickerIntl()); }
    return this.__MdDatepickerIntl_189;
  }
  get _MdIconRegistry_190():any {
    if ((this.__MdIconRegistry_190 == null)) { (this.__MdIconRegistry_190 = import5.ICON_REGISTRY_PROVIDER_FACTORY(this.parent.get(import5.MdIconRegistry,(null as any)),this._Http_164,this._DomSanitizer_142)); }
    return this.__MdIconRegistry_190;
  }
  get _MdSnackBar_191():import5.MdSnackBar {
    if ((this.__MdSnackBar_191 == null)) { (this.__MdSnackBar_191 = new import5.MdSnackBar(this._Overlay_183,this._LiveAnnouncer_187,this.parent.get(import5.MdSnackBar,(null as any)))); }
    return this.__MdSnackBar_191;
  }
  get _ɵa_192():import5.ɵa {
    if ((this.__ɵa_192 == null)) { (this.__ɵa_192 = new import5.ɵa()); }
    return this.__ɵa_192;
  }
  get _AuthTokenGuard_193():import81.AuthTokenGuard {
    if ((this.__AuthTokenGuard_193 == null)) { (this.__AuthTokenGuard_193 = new import81.AuthTokenGuard()); }
    return this.__AuthTokenGuard_193;
  }
  get _NotificationsService_194():import82.NotificationsService {
    if ((this.__NotificationsService_194 == null)) { (this.__NotificationsService_194 = new import82.NotificationsService()); }
    return this.__NotificationsService_194;
  }
  get _PerfectScrollbarConfig_196():any {
    if ((this.__PerfectScrollbarConfig_196 == null)) { (this.__PerfectScrollbarConfig_196 = import40.provideDefaultConfig(this._PERFECT_SCROLLBAR_CONFIG_195)); }
    return this.__PerfectScrollbarConfig_196;
  }
  get _WindowRef_197():import83.WindowRef {
    if ((this.__WindowRef_197 == null)) { (this.__WindowRef_197 = new import83.WindowRef()); }
    return this.__WindowRef_197;
  }
  get _DocumentRef_198():import83.DocumentRef {
    if ((this.__DocumentRef_198 == null)) { (this.__DocumentRef_198 = new import83.DocumentRef()); }
    return this.__DocumentRef_198;
  }
  get _MapsAPILoader_200():import84.LazyMapsAPILoader {
    if ((this.__MapsAPILoader_200 == null)) { (this.__MapsAPILoader_200 = new import84.LazyMapsAPILoader(this._LAZY_MAPS_API_CONFIG_199,this._WindowRef_197,this._DocumentRef_198)); }
    return this.__MapsAPILoader_200;
  }
  get _ActivatedRoute_201():any {
    if ((this.__ActivatedRoute_201 == null)) { (this.__ActivatedRoute_201 = import6.ɵf(this._Router_29)); }
    return this.__ActivatedRoute_201;
  }
  get _NoPreloading_202():import6.NoPreloading {
    if ((this.__NoPreloading_202 == null)) { (this.__NoPreloading_202 = new import6.NoPreloading()); }
    return this.__NoPreloading_202;
  }
  get _PreloadingStrategy_203():any {
    if ((this.__PreloadingStrategy_203 == null)) { (this.__PreloadingStrategy_203 = this._NoPreloading_202); }
    return this.__PreloadingStrategy_203;
  }
  get _RouterPreloader_204():import6.RouterPreloader {
    if ((this.__RouterPreloader_204 == null)) { (this.__RouterPreloader_204 = new import6.RouterPreloader(this._Router_29,this._NgModuleFactoryLoader_26,this._Compiler_25,this,this._PreloadingStrategy_203)); }
    return this.__RouterPreloader_204;
  }
  get _PreloadAllModules_205():import6.PreloadAllModules {
    if ((this.__PreloadAllModules_205 == null)) { (this.__PreloadAllModules_205 = new import6.PreloadAllModules()); }
    return this.__PreloadAllModules_205;
  }
  get _ROUTER_INITIALIZER_206():any {
    if ((this.__ROUTER_INITIALIZER_206 == null)) { (this.__ROUTER_INITIALIZER_206 = import6.ɵi(this._ɵg_12)); }
    return this.__ROUTER_INITIALIZER_206;
  }
  get _APP_BOOTSTRAP_LISTENER_207():any[] {
    if ((this.__APP_BOOTSTRAP_LISTENER_207 == null)) { (this.__APP_BOOTSTRAP_LISTENER_207 = [this._ROUTER_INITIALIZER_206]); }
    return this.__APP_BOOTSTRAP_LISTENER_207;
  }
  get _DatePipe_208():import3.DatePipe {
    if ((this.__DatePipe_208 == null)) { (this.__DatePipe_208 = new import3.DatePipe(this._LOCALE_ID_133)); }
    return this.__DatePipe_208;
  }
  get _RolePermission_209():import85.RolePermission {
    if ((this.__RolePermission_209 == null)) { (this.__RolePermission_209 = new import85.RolePermission(this._Http_164)); }
    return this.__RolePermission_209;
  }
  get _LinkAuth_210():import86.LinkAuth {
    if ((this.__LinkAuth_210 == null)) { (this.__LinkAuth_210 = new import86.LinkAuth(this._RolePermission_209)); }
    return this.__LinkAuth_210;
  }
  get _UserNameService_211():import87.UserNameService {
    if ((this.__UserNameService_211 == null)) { (this.__UserNameService_211 = new import87.UserNameService()); }
    return this.__UserNameService_211;
  }
  get _AuthGuard_212():import88.AuthGuard {
    if ((this.__AuthGuard_212 == null)) { (this.__AuthGuard_212 = new import88.AuthGuard(this._Router_29,this._RolePermission_209)); }
    return this.__AuthGuard_212;
  }
  get _VerifiedGuard_213():import89.VerifiedGuard {
    if ((this.__VerifiedGuard_213 == null)) { (this.__VerifiedGuard_213 = new import89.VerifiedGuard()); }
    return this.__VerifiedGuard_213;
  }
  get _NoAuthGuard_214():import90.NoAuthGuard {
    if ((this.__NoAuthGuard_214 == null)) { (this.__NoAuthGuard_214 = new import90.NoAuthGuard()); }
    return this.__NoAuthGuard_214;
  }
  get _LinkHelper_215():import86.LinkHelper {
    if ((this.__LinkHelper_215 == null)) { (this.__LinkHelper_215 = new import86.LinkHelper()); }
    return this.__LinkHelper_215;
  }
  get _NotificationServiceBus_216():import91.NotificationServiceBus {
    if ((this.__NotificationServiceBus_216 == null)) { (this.__NotificationServiceBus_216 = new import91.NotificationServiceBus(this.parent.get(import0.NgZone))); }
    return this.__NotificationServiceBus_216;
  }
  get _SpinnerService_217():import92.SpinnerService {
    if ((this.__SpinnerService_217 == null)) { (this.__SpinnerService_217 = new import92.SpinnerService()); }
    return this.__SpinnerService_217;
  }
  get _AuthHttp_218():any {
    if ((this.__AuthHttp_218 == null)) { (this.__AuthHttp_218 = import136.authService(this._Http_164,this._RequestOptions_163)); }
    return this.__AuthHttp_218;
  }
  get _PopupService_219():import93.PopupService {
    if ((this.__PopupService_219 == null)) { (this.__PopupService_219 = new import93.PopupService()); }
    return this.__PopupService_219;
  }
  get _BookingService_220():import94.BookingService {
    if ((this.__BookingService_220 == null)) { (this.__BookingService_220 = new import94.BookingService(this._AuthHttp_218,this._Router_29,this._PopupService_219)); }
    return this.__BookingService_220;
  }
  get _UserService_221():import95.UserService {
    if ((this.__UserService_221 == null)) { (this.__UserService_221 = new import95.UserService(this._AuthHttp_218,this._Router_29,this._PopupService_219)); }
    return this.__UserService_221;
  }
  get _PreferedAllocationService_222():import96.PreferedAllocationService {
    if ((this.__PreferedAllocationService_222 == null)) { (this.__PreferedAllocationService_222 = new import96.PreferedAllocationService()); }
    return this.__PreferedAllocationService_222;
  }
  get _BookingHeaderService_223():import97.BookingHeaderService {
    if ((this.__BookingHeaderService_223 == null)) { (this.__BookingHeaderService_223 = new import97.BookingHeaderService()); }
    return this.__BookingHeaderService_223;
  }
  get _GmapsApiService_224():import98.GmapsApiService {
    if ((this.__GmapsApiService_224 == null)) { (this.__GmapsApiService_224 = new import98.GmapsApiService(this._AuthHttp_218,this._Router_29,this._PopupService_219)); }
    return this.__GmapsApiService_224;
  }
  get _MessagingService_225():import99.MessagingService {
    if ((this.__MessagingService_225 == null)) { (this.__MessagingService_225 = new import99.MessagingService(this._AuthHttp_218,this._Router_29,this._PopupService_219)); }
    return this.__MessagingService_225;
  }
  get _BookingListMultiSelectService_226():import100.BookingListMultiSelectService<any,any> {
    if ((this.__BookingListMultiSelectService_226 == null)) { (this.__BookingListMultiSelectService_226 = new import100.BookingListMultiSelectService<any,any>()); }
    return this.__BookingListMultiSelectService_226;
  }
  get _SubOrganisationFilterService_227():import101.SubOrganisationFilterService {
    if ((this.__SubOrganisationFilterService_227 == null)) { (this.__SubOrganisationFilterService_227 = new import101.SubOrganisationFilterService()); }
    return this.__SubOrganisationFilterService_227;
  }
  createInternal():import1.AppModule {
    this._CustomFormsModule_0 = new import2.CustomFormsModule();
    this._CommonModule_1 = new import3.CommonModule();
    this._FileUploadModule_2 = new import4.FileUploadModule();
    this._MATERIAL_SANITY_CHECKS_3 = true;
    this._CompatibilityModule_4 = new import5.CompatibilityModule(this.parent.get(import7.DOCUMENT,(null as any)),this._MATERIAL_SANITY_CHECKS_3);
    this._MdCommonModule_5 = new import5.MdCommonModule();
    this._PlatformModule_6 = new import5.PlatformModule();
    this._ɵm_7 = new import5.ɵm();
    this._MdRippleModule_8 = new import5.MdRippleModule();
    this._MdCheckboxModule_9 = new import5.MdCheckboxModule();
    this._ErrorHandler_10 = import7.ɵa();
    this._NgProbeToken_11 = [import6.ɵb()];
    this._ɵg_12 = new import6.ɵg(this);
    this._APP_INITIALIZER_13 = [
      import0.ɵo,
      import7.ɵc(this.parent.get(import7.NgProbeToken,(null as any)),this._NgProbeToken_11),
      import6.ɵh(this._ɵg_12)
    ]
    ;
    this._ApplicationInitStatus_14 = new import0.ApplicationInitStatus(this._APP_INITIALIZER_13);
    this._ɵf_15 = new import0.ɵf(this.parent.get(import0.NgZone),this.parent.get(import0.ɵConsole),this,this._ErrorHandler_10,this.componentFactoryResolver,this._ApplicationInitStatus_14);
    this._ApplicationRef_16 = this._ɵf_15;
    this._ApplicationModule_17 = new import0.ApplicationModule(this._ApplicationRef_16);
    this._BrowserModule_18 = new import7.BrowserModule(this.parent.get(import7.BrowserModule,(null as any)));
    this._ɵa_19 = import6.ɵd(this.parent.get(import6.Router,(null as any)));
    this._UrlSerializer_20 = new import6.DefaultUrlSerializer();
    this._RouterOutletMap_21 = new import6.RouterOutletMap();
    this._APP_BASE_HREF_22 = '/';
    this._LocationStrategy_23 = new import3.HashLocationStrategy(this.parent.get(import3.PlatformLocation),this._APP_BASE_HREF_22);
    this._Location_24 = new import3.Location(this._LocationStrategy_23);
    this._Compiler_25 = new import0.Compiler();
    this._NgModuleFactoryLoader_26 = new import0.SystemJsNgModuleLoader(this._Compiler_25,this.parent.get(import0.SystemJsNgModuleLoaderConfig,(null as any)));
    this._ROUTES_27 = [
      [
        {
          path: 'authenticate',
          component: import137.LoginComponent
        }
        ,
        {
          path: 'authenticate/logout',
          component: import137.LoginComponent
        }
        ,
        {
          path: 'register/pre',
          component: import138.PreComponent,
          canActivate: [import90.NoAuthGuard]
        }
        ,
        {
          path: 'register',
          component: import139.RegisterComponent,
          canActivate: [import90.NoAuthGuard]
        }
        ,
        {
          path: 'reset',
          component: import140.ResetComponent,
          canActivate: [import90.NoAuthGuard]
        }
        ,
        {
          path: 'verify/:id',
          component: import141.VerifyComponent,
          canActivate: [import88.AuthGuard]
        }
        ,
        {
          path: 'update-password',
          component: import142.UpdatePasswordComponent,
          canActivate: [import81.AuthTokenGuard]
        }

      ]
      ,
      [
        {
          path: 'user-management',
          component: import143.UserManagementComponent,
          canActivate: [
            import88.AuthGuard,
            import89.VerifiedGuard
          ]

        }
        ,
        {
          path: 'user-management/profile',
          component: import144.UserProfileComponent,
          canActivate: [
            import88.AuthGuard,
            import89.VerifiedGuard
          ]

        }
        ,
        {
          path: 'user-management/secure_pass',
          component: import145.UserPasswordComponent,
          canActivate: [
            import88.AuthGuard,
            import89.VerifiedGuard
          ]

        }
        ,
        {
          path: 'user-management/:id/skills',
          component: import146.SkillMatrixComponent,
          canActivate: [
            import88.AuthGuard,
            import89.VerifiedGuard
          ]

        }
        ,
        {
          path: 'user-management/:id/block_out',
          component: import147.BlockoutComponent,
          canActivate: [
            import88.AuthGuard,
            import89.VerifiedGuard
          ]

        }
        ,
        {
          path: 'user-management/:id/staff-availability',
          component: import147.BlockoutComponent,
          canActivate: [
            import88.AuthGuard,
            import89.VerifiedGuard
          ]

        }
        ,
        {
          path: 'user-management/:id/staff_calendar',
          component: import148.StaffCalendarComponent,
          canActivate: [
            import88.AuthGuard,
            import89.VerifiedGuard
          ]

        }
        ,
        {
          path: 'user-management/payroll-billing',
          component: import149.UserPayrollBillingComponent,
          canActivate: [
            import88.AuthGuard,
            import89.VerifiedGuard
          ]

        }
        ,
        {
          path: 'booking-management',
          component: import150.BookingComponent,
          canActivate: [
            import88.AuthGuard,
            import89.VerifiedGuard
          ]

        }
        ,
        {
          path: 'booking-management/:id/create-booking-old',
          component: import151.BookingDetailComponent,
          canActivate: [
            import88.AuthGuard,
            import89.VerifiedGuard
          ]

        }
        ,
        {
          path: 'booking-management/create-booking',
          component: import152.BookingFormComponent,
          canActivate: [
            import88.AuthGuard,
            import89.VerifiedGuard
          ]

        }
        ,
        {
          path: 'booking-management/create-booking-old',
          component: import151.BookingDetailComponent,
          canActivate: [
            import88.AuthGuard,
            import89.VerifiedGuard
          ]

        }
        ,
        {
          path: 'booking-management/:id/booking-job',
          component: import153.BookingJobsComponent,
          canActivate: [
            import88.AuthGuard,
            import89.VerifiedGuard
          ]

        }
        ,
        {
          path: 'booking-management/:id/job-detail',
          component: import153.BookingJobsComponent,
          canActivate: [
            import88.AuthGuard,
            import89.VerifiedGuard
          ]

        }
        ,
        {
          path: 'booking-management/edit-booking-old',
          component: import151.BookingDetailComponent,
          canActivate: [
            import88.AuthGuard,
            import89.VerifiedGuard
          ]

        }
        ,
        {
          path: 'booking-management/edit-booking',
          component: import152.BookingFormComponent,
          canActivate: [
            import88.AuthGuard,
            import89.VerifiedGuard
          ]

        }
        ,
        {
          path: 'booking-management/:id/payroll-billing',
          component: import154.BookingPayrollComponent,
          canActivate: [
            import88.AuthGuard,
            import89.VerifiedGuard
          ]

        }
        ,
        {
          path: 'users/:id/inbox',
          component: import155.InboxComponent,
          canActivate: [
            import88.AuthGuard,
            import89.VerifiedGuard
          ]

        }
        ,
        {
          path: 'users/:id/inbox/:id2',
          component: import155.InboxComponent,
          canActivate: [
            import88.AuthGuard,
            import89.VerifiedGuard
          ]

        }
        ,
        {
          path: 'reports',
          component: import156.ReportsComponent,
          canActivate: [
            import88.AuthGuard,
            import89.VerifiedGuard
          ]

        }
        ,
        {
          path: '404',
          component: import157.NotFoundComponent
        }
        ,
        {
          path: 'dashboard',
          component: import158.DashboardComponent,
          canActivate: [import81.AuthTokenGuard]
        }
        ,
        {
          path: 'init',
          component: import139.RegisterComponent,
          canActivate: [
            import88.AuthGuard,
            import89.VerifiedGuard
          ]

        }
        ,
        {
          path: 'bookings',
          component: import150.BookingComponent,
          canActivate: [
            import88.AuthGuard,
            import89.VerifiedGuard
          ]

        }
        ,
        {
          path: '**',
          redirectTo: 'authenticate',
          pathMatch: 'full'
        }

      ]

    ]
    ;
    this._ROUTER_CONFIGURATION_28 = {enableTracing: false};
    this._Router_29 = import6.ɵe(this._ApplicationRef_16,this._UrlSerializer_20,this._RouterOutletMap_21,this._Location_24,this,this._NgModuleFactoryLoader_26,this._Compiler_25,this._ROUTES_27,this._ROUTER_CONFIGURATION_28,this.parent.get(import6.UrlHandlingStrategy,(null as any)),this.parent.get(import6.RouteReuseStrategy,(null as any)));
    this._RouterModule_30 = new import6.RouterModule(this._ɵa_19,this._Router_29);
    this._MobileFooterModule_31 = new import8.MobileFooterModule();
    this._ɵba_32 = new import9.ɵba();
    this._FormsModule_33 = new import9.FormsModule();
    this._BrowserAnimationsModule_34 = new import10.BrowserAnimationsModule();
    this._NgxPaginationModule_35 = new import11.NgxPaginationModule();
    this._HttpModule_36 = new import12.HttpModule();
    this._SimpleNotificationsModule_37 = new import13.SimpleNotificationsModule();
    this._ReactiveFormsModule_38 = new import9.ReactiveFormsModule();
    this._Md2AccordionModule_39 = new import14.Md2AccordionModule();
    this._Md2AutocompleteModule_40 = new import15.Md2AutocompleteModule();
    this._Md2ChipsModule_41 = new import16.Md2ChipsModule();
    this._Md2CollapseModule_42 = new import17.Md2CollapseModule();
    this._PortalModule_43 = new import18.PortalModule();
    this._OverlayModule_44 = new import19.OverlayModule();
    this._Md2ColorpickerModule_45 = new import20.Md2ColorpickerModule();
    this._MdSelectionModule_46 = new import21.MdSelectionModule();
    this._Md2OptionModule_47 = new import22.Md2OptionModule();
    this._CompatibilityModule_48 = new import23.CompatibilityModule(this.parent.get(import7.DOCUMENT,(null as any)));
    this._Md2SelectModule_49 = new import24.Md2SelectModule();
    this._Md2DataTableModule_50 = new import25.Md2DataTableModule();
    this._Md2DatepickerModule_51 = new import26.Md2DatepickerModule();
    this._Md2DialogModule_52 = new import27.Md2DialogModule();
    this._Md2MenuModule_53 = new import28.Md2MenuModule();
    this._MdRippleModule_54 = new import29.MdRippleModule();
    this._Md2TabsModule_55 = new import30.Md2TabsModule();
    this._Md2TagsModule_56 = new import31.Md2TagsModule();
    this._Md2ToastModule_57 = new import32.Md2ToastModule();
    this._PlatformModule_58 = new import33.PlatformModule();
    this._Md2TooltipModule_59 = new import34.Md2TooltipModule();
    this._RtlModule_60 = new import35.RtlModule();
    this._ObserveContentModule_61 = new import36.ObserveContentModule();
    this._A11yModule_62 = new import37.A11yModule();
    this._StyleModule_63 = new import38.StyleModule();
    this._Md2RootModule_64 = new import39.Md2RootModule();
    this._PERFECT_SCROLLBAR_GUARD_65 = import40.provideForRootGuard(this.parent.get(import159.PerfectScrollbarConfig,(null as any)));
    this._PerfectScrollbarModule_66 = new import40.PerfectScrollbarModule(this._PERFECT_SCROLLBAR_GUARD_65);
    this._MdSelectionModule_67 = new import5.MdSelectionModule();
    this._MdOptionModule_68 = new import5.MdOptionModule();
    this._PortalModule_69 = new import5.PortalModule();
    this._OverlayModule_70 = new import5.OverlayModule();
    this._MdAutocompleteModule_71 = new import5.MdAutocompleteModule();
    this._StyleModule_72 = new import5.StyleModule();
    this._MdButtonModule_73 = new import5.MdButtonModule();
    this._MdButtonToggleModule_74 = new import5.MdButtonToggleModule();
    this._MdCardModule_75 = new import5.MdCardModule();
    this._MdChipsModule_76 = new import5.MdChipsModule();
    this._A11yModule_77 = new import5.A11yModule();
    this._MdDialogModule_78 = new import5.MdDialogModule();
    this._MdDatepickerModule_79 = new import5.MdDatepickerModule();
    this._MdLineModule_80 = new import5.MdLineModule();
    this._MdGridListModule_81 = new import5.MdGridListModule();
    this._MdIconModule_82 = new import5.MdIconModule();
    this._MdInputModule_83 = new import5.MdInputModule();
    this._MdListModule_84 = new import5.MdListModule();
    this._MdMenuModule_85 = new import5.MdMenuModule();
    this._MdProgressBarModule_86 = new import5.MdProgressBarModule();
    this._MdProgressSpinnerModule_87 = new import5.MdProgressSpinnerModule();
    this._MdRadioModule_88 = new import5.MdRadioModule();
    this._MdSelectModule_89 = new import5.MdSelectModule();
    this._MdSidenavModule_90 = new import5.MdSidenavModule();
    this._RtlModule_91 = new import5.RtlModule();
    this._MdSliderModule_92 = new import5.MdSliderModule();
    this._MdSlideToggleModule_93 = new import5.MdSlideToggleModule();
    this._MdSnackBarModule_94 = new import5.MdSnackBarModule();
    this._ObserveContentModule_95 = new import5.ObserveContentModule();
    this._MdTabsModule_96 = new import5.MdTabsModule();
    this._MdToolbarModule_97 = new import5.MdToolbarModule();
    this._MdTooltipModule_98 = new import5.MdTooltipModule();
    this._MaterialModule_99 = new import5.MaterialModule();
    this._CalendarModule_100 = new import41.CalendarModule();
    this._ButtonModule_101 = new import42.ButtonModule();
    this._SharedModule_102 = new import43.SharedModule();
    this._CalendarModule_103 = new import44.CalendarModule();
    this._AgmCoreModule_104 = new import45.AgmCoreModule();
    this._InputTextModule_105 = new import46.InputTextModule();
    this._AutoCompleteModule_106 = new import47.AutoCompleteModule();
    this._AngularMultiSelectModule_107 = new import48.AngularMultiSelectModule();
    this._PipeModule_108 = new import49.PipeModule();
    this._AddressModule_109 = new import50.AddressModule();
    this._BillingAccountModule_110 = new import51.BillingAccountModule();
    this._IndClientModule_111 = new import52.IndClientModule();
    this._InterpreterModule_112 = new import53.InterpreterModule();
    this._InterpreterBoxModule_113 = new import54.InterpreterBoxModule();
    this._MobileHeaderModule_114 = new import55.MobileHeaderModule();
    this._OrgRepModule_115 = new import56.OrgRepModule();
    this._TermandconditionModule_116 = new import57.TermandconditionModule();
    this._SharedModule_117 = new import58.SharedModule();
    this._PasswordValidatorModule_118 = new import59.PasswordValidatorModule();
    this._ModalModule_119 = new import60.ModalModule();
    this._LoginModule_120 = new import61.LoginModule();
    this._PreModule_121 = new import62.PreModule();
    this._RegisterModule_122 = new import63.RegisterModule();
    this._ResetModule_123 = new import64.ResetModule();
    this._VerifyModule_124 = new import65.VerifyModule();
    this._UserPasswordFormModule_125 = new import66.UserPasswordFormModule();
    this._UpdatePasswordModule_126 = new import67.UpdatePasswordModule();
    this._AuthModule_127 = new import68.AuthModule();
    this._BookingHeaderModule_128 = new import69.BookingHeaderModule();
    this._AddInterpretersModule_129 = new import70.AddInterpretersModule();
    this._BookingFormModule_130 = new import71.BookingFormModule();
    this._ScreenGuardModule_131 = new import72.ScreenGuardModule();
    this._AppModule_132 = new import1.AppModule(this._Location_24);
    this._PERFECT_SCROLLBAR_CONFIG_195 = {suppressScrollX: true};
    this._LAZY_MAPS_API_CONFIG_199 = {
      apiKey: 'AIzaSyCFlZ1psfA1dNZ2yC4GGVj54X1I35xh8iM',
      libraries: ['places']
    }
    ;
    return this._AppModule_132;
  }
  getInternal(token:any,notFoundResult:any):any {
    if ((token === import2.CustomFormsModule)) { return this._CustomFormsModule_0; }
    if ((token === import3.CommonModule)) { return this._CommonModule_1; }
    if ((token === import4.FileUploadModule)) { return this._FileUploadModule_2; }
    if ((token === import5.MATERIAL_SANITY_CHECKS)) { return this._MATERIAL_SANITY_CHECKS_3; }
    if ((token === import5.CompatibilityModule)) { return this._CompatibilityModule_4; }
    if ((token === import5.MdCommonModule)) { return this._MdCommonModule_5; }
    if ((token === import5.PlatformModule)) { return this._PlatformModule_6; }
    if ((token === import5.ɵm)) { return this._ɵm_7; }
    if ((token === import5.MdRippleModule)) { return this._MdRippleModule_8; }
    if ((token === import5.MdCheckboxModule)) { return this._MdCheckboxModule_9; }
    if ((token === import0.ErrorHandler)) { return this._ErrorHandler_10; }
    if ((token === import0.NgProbeToken)) { return this._NgProbeToken_11; }
    if ((token === import6.ɵg)) { return this._ɵg_12; }
    if ((token === import0.APP_INITIALIZER)) { return this._APP_INITIALIZER_13; }
    if ((token === import0.ApplicationInitStatus)) { return this._ApplicationInitStatus_14; }
    if ((token === import0.ɵf)) { return this._ɵf_15; }
    if ((token === import0.ApplicationRef)) { return this._ApplicationRef_16; }
    if ((token === import0.ApplicationModule)) { return this._ApplicationModule_17; }
    if ((token === import7.BrowserModule)) { return this._BrowserModule_18; }
    if ((token === import6.ɵa)) { return this._ɵa_19; }
    if ((token === import6.UrlSerializer)) { return this._UrlSerializer_20; }
    if ((token === import6.RouterOutletMap)) { return this._RouterOutletMap_21; }
    if ((token === import3.APP_BASE_HREF)) { return this._APP_BASE_HREF_22; }
    if ((token === import3.LocationStrategy)) { return this._LocationStrategy_23; }
    if ((token === import3.Location)) { return this._Location_24; }
    if ((token === import0.Compiler)) { return this._Compiler_25; }
    if ((token === import0.NgModuleFactoryLoader)) { return this._NgModuleFactoryLoader_26; }
    if ((token === import6.ROUTES)) { return this._ROUTES_27; }
    if ((token === import6.ROUTER_CONFIGURATION)) { return this._ROUTER_CONFIGURATION_28; }
    if ((token === import6.Router)) { return this._Router_29; }
    if ((token === import6.RouterModule)) { return this._RouterModule_30; }
    if ((token === import8.MobileFooterModule)) { return this._MobileFooterModule_31; }
    if ((token === import9.ɵba)) { return this._ɵba_32; }
    if ((token === import9.FormsModule)) { return this._FormsModule_33; }
    if ((token === import10.BrowserAnimationsModule)) { return this._BrowserAnimationsModule_34; }
    if ((token === import11.NgxPaginationModule)) { return this._NgxPaginationModule_35; }
    if ((token === import12.HttpModule)) { return this._HttpModule_36; }
    if ((token === import13.SimpleNotificationsModule)) { return this._SimpleNotificationsModule_37; }
    if ((token === import9.ReactiveFormsModule)) { return this._ReactiveFormsModule_38; }
    if ((token === import14.Md2AccordionModule)) { return this._Md2AccordionModule_39; }
    if ((token === import15.Md2AutocompleteModule)) { return this._Md2AutocompleteModule_40; }
    if ((token === import16.Md2ChipsModule)) { return this._Md2ChipsModule_41; }
    if ((token === import17.Md2CollapseModule)) { return this._Md2CollapseModule_42; }
    if ((token === import18.PortalModule)) { return this._PortalModule_43; }
    if ((token === import19.OverlayModule)) { return this._OverlayModule_44; }
    if ((token === import20.Md2ColorpickerModule)) { return this._Md2ColorpickerModule_45; }
    if ((token === import21.MdSelectionModule)) { return this._MdSelectionModule_46; }
    if ((token === import22.Md2OptionModule)) { return this._Md2OptionModule_47; }
    if ((token === import23.CompatibilityModule)) { return this._CompatibilityModule_48; }
    if ((token === import24.Md2SelectModule)) { return this._Md2SelectModule_49; }
    if ((token === import25.Md2DataTableModule)) { return this._Md2DataTableModule_50; }
    if ((token === import26.Md2DatepickerModule)) { return this._Md2DatepickerModule_51; }
    if ((token === import27.Md2DialogModule)) { return this._Md2DialogModule_52; }
    if ((token === import28.Md2MenuModule)) { return this._Md2MenuModule_53; }
    if ((token === import29.MdRippleModule)) { return this._MdRippleModule_54; }
    if ((token === import30.Md2TabsModule)) { return this._Md2TabsModule_55; }
    if ((token === import31.Md2TagsModule)) { return this._Md2TagsModule_56; }
    if ((token === import32.Md2ToastModule)) { return this._Md2ToastModule_57; }
    if ((token === import33.PlatformModule)) { return this._PlatformModule_58; }
    if ((token === import34.Md2TooltipModule)) { return this._Md2TooltipModule_59; }
    if ((token === import35.RtlModule)) { return this._RtlModule_60; }
    if ((token === import36.ObserveContentModule)) { return this._ObserveContentModule_61; }
    if ((token === import37.A11yModule)) { return this._A11yModule_62; }
    if ((token === import38.StyleModule)) { return this._StyleModule_63; }
    if ((token === import39.Md2RootModule)) { return this._Md2RootModule_64; }
    if ((token === import40.PERFECT_SCROLLBAR_GUARD)) { return this._PERFECT_SCROLLBAR_GUARD_65; }
    if ((token === import40.PerfectScrollbarModule)) { return this._PerfectScrollbarModule_66; }
    if ((token === import5.MdSelectionModule)) { return this._MdSelectionModule_67; }
    if ((token === import5.MdOptionModule)) { return this._MdOptionModule_68; }
    if ((token === import5.PortalModule)) { return this._PortalModule_69; }
    if ((token === import5.OverlayModule)) { return this._OverlayModule_70; }
    if ((token === import5.MdAutocompleteModule)) { return this._MdAutocompleteModule_71; }
    if ((token === import5.StyleModule)) { return this._StyleModule_72; }
    if ((token === import5.MdButtonModule)) { return this._MdButtonModule_73; }
    if ((token === import5.MdButtonToggleModule)) { return this._MdButtonToggleModule_74; }
    if ((token === import5.MdCardModule)) { return this._MdCardModule_75; }
    if ((token === import5.MdChipsModule)) { return this._MdChipsModule_76; }
    if ((token === import5.A11yModule)) { return this._A11yModule_77; }
    if ((token === import5.MdDialogModule)) { return this._MdDialogModule_78; }
    if ((token === import5.MdDatepickerModule)) { return this._MdDatepickerModule_79; }
    if ((token === import5.MdLineModule)) { return this._MdLineModule_80; }
    if ((token === import5.MdGridListModule)) { return this._MdGridListModule_81; }
    if ((token === import5.MdIconModule)) { return this._MdIconModule_82; }
    if ((token === import5.MdInputModule)) { return this._MdInputModule_83; }
    if ((token === import5.MdListModule)) { return this._MdListModule_84; }
    if ((token === import5.MdMenuModule)) { return this._MdMenuModule_85; }
    if ((token === import5.MdProgressBarModule)) { return this._MdProgressBarModule_86; }
    if ((token === import5.MdProgressSpinnerModule)) { return this._MdProgressSpinnerModule_87; }
    if ((token === import5.MdRadioModule)) { return this._MdRadioModule_88; }
    if ((token === import5.MdSelectModule)) { return this._MdSelectModule_89; }
    if ((token === import5.MdSidenavModule)) { return this._MdSidenavModule_90; }
    if ((token === import5.RtlModule)) { return this._RtlModule_91; }
    if ((token === import5.MdSliderModule)) { return this._MdSliderModule_92; }
    if ((token === import5.MdSlideToggleModule)) { return this._MdSlideToggleModule_93; }
    if ((token === import5.MdSnackBarModule)) { return this._MdSnackBarModule_94; }
    if ((token === import5.ObserveContentModule)) { return this._ObserveContentModule_95; }
    if ((token === import5.MdTabsModule)) { return this._MdTabsModule_96; }
    if ((token === import5.MdToolbarModule)) { return this._MdToolbarModule_97; }
    if ((token === import5.MdTooltipModule)) { return this._MdTooltipModule_98; }
    if ((token === import5.MaterialModule)) { return this._MaterialModule_99; }
    if ((token === import41.CalendarModule)) { return this._CalendarModule_100; }
    if ((token === import42.ButtonModule)) { return this._ButtonModule_101; }
    if ((token === import43.SharedModule)) { return this._SharedModule_102; }
    if ((token === import44.CalendarModule)) { return this._CalendarModule_103; }
    if ((token === import45.AgmCoreModule)) { return this._AgmCoreModule_104; }
    if ((token === import46.InputTextModule)) { return this._InputTextModule_105; }
    if ((token === import47.AutoCompleteModule)) { return this._AutoCompleteModule_106; }
    if ((token === import48.AngularMultiSelectModule)) { return this._AngularMultiSelectModule_107; }
    if ((token === import49.PipeModule)) { return this._PipeModule_108; }
    if ((token === import50.AddressModule)) { return this._AddressModule_109; }
    if ((token === import51.BillingAccountModule)) { return this._BillingAccountModule_110; }
    if ((token === import52.IndClientModule)) { return this._IndClientModule_111; }
    if ((token === import53.InterpreterModule)) { return this._InterpreterModule_112; }
    if ((token === import54.InterpreterBoxModule)) { return this._InterpreterBoxModule_113; }
    if ((token === import55.MobileHeaderModule)) { return this._MobileHeaderModule_114; }
    if ((token === import56.OrgRepModule)) { return this._OrgRepModule_115; }
    if ((token === import57.TermandconditionModule)) { return this._TermandconditionModule_116; }
    if ((token === import58.SharedModule)) { return this._SharedModule_117; }
    if ((token === import59.PasswordValidatorModule)) { return this._PasswordValidatorModule_118; }
    if ((token === import60.ModalModule)) { return this._ModalModule_119; }
    if ((token === import61.LoginModule)) { return this._LoginModule_120; }
    if ((token === import62.PreModule)) { return this._PreModule_121; }
    if ((token === import63.RegisterModule)) { return this._RegisterModule_122; }
    if ((token === import64.ResetModule)) { return this._ResetModule_123; }
    if ((token === import65.VerifyModule)) { return this._VerifyModule_124; }
    if ((token === import66.UserPasswordFormModule)) { return this._UserPasswordFormModule_125; }
    if ((token === import67.UpdatePasswordModule)) { return this._UpdatePasswordModule_126; }
    if ((token === import68.AuthModule)) { return this._AuthModule_127; }
    if ((token === import69.BookingHeaderModule)) { return this._BookingHeaderModule_128; }
    if ((token === import70.AddInterpretersModule)) { return this._AddInterpretersModule_129; }
    if ((token === import71.BookingFormModule)) { return this._BookingFormModule_130; }
    if ((token === import72.ScreenGuardModule)) { return this._ScreenGuardModule_131; }
    if ((token === import1.AppModule)) { return this._AppModule_132; }
    if ((token === import0.LOCALE_ID)) { return this._LOCALE_ID_133; }
    if ((token === import3.NgLocalization)) { return this._NgLocalization_134; }
    if ((token === import5.Platform)) { return this._Platform_135; }
    if ((token === import5.ScrollDispatcher)) { return this._ScrollDispatcher_136; }
    if ((token === import5.ɵo)) { return this._ɵo_137; }
    if ((token === import5.FocusOriginMonitor)) { return this._FocusOriginMonitor_138; }
    if ((token === import0.APP_ID)) { return this._APP_ID_139; }
    if ((token === import0.IterableDiffers)) { return this._IterableDiffers_140; }
    if ((token === import0.KeyValueDiffers)) { return this._KeyValueDiffers_141; }
    if ((token === import7.DomSanitizer)) { return this._DomSanitizer_142; }
    if ((token === import0.Sanitizer)) { return this._Sanitizer_143; }
    if ((token === import7.HAMMER_GESTURE_CONFIG)) { return this._HAMMER_GESTURE_CONFIG_144; }
    if ((token === import7.EVENT_MANAGER_PLUGINS)) { return this._EVENT_MANAGER_PLUGINS_145; }
    if ((token === import7.EventManager)) { return this._EventManager_146; }
    if ((token === import7.ɵDomSharedStylesHost)) { return this._ɵDomSharedStylesHost_147; }
    if ((token === import7.ɵDomRendererFactory2)) { return this._ɵDomRendererFactory2_148; }
    if ((token === import160.AnimationDriver)) { return this._AnimationDriver_149; }
    if ((token === import160.ɵAnimationStyleNormalizer)) { return this._ɵAnimationStyleNormalizer_150; }
    if ((token === import160.ɵAnimationEngine)) { return this._ɵAnimationEngine_151; }
    if ((token === import0.RendererFactory2)) { return this._RendererFactory2_152; }
    if ((token === import7.ɵSharedStylesHost)) { return this._ɵSharedStylesHost_153; }
    if ((token === import0.Testability)) { return this._Testability_154; }
    if ((token === import7.Meta)) { return this._Meta_155; }
    if ((token === import7.Title)) { return this._Title_156; }
    if ((token === import9.ɵi)) { return this._ɵi_157; }
    if ((token === import11.PaginationService)) { return this._PaginationService_158; }
    if ((token === import12.BrowserXhr)) { return this._BrowserXhr_159; }
    if ((token === import12.ResponseOptions)) { return this._ResponseOptions_160; }
    if ((token === import12.XSRFStrategy)) { return this._XSRFStrategy_161; }
    if ((token === import12.XHRBackend)) { return this._XHRBackend_162; }
    if ((token === import12.RequestOptions)) { return this._RequestOptions_163; }
    if ((token === import12.Http)) { return this._Http_164; }
    if ((token === import9.FormBuilder)) { return this._FormBuilder_165; }
    if ((token === import131.OverlayContainer)) { return this._OverlayContainer_166; }
    if ((token === import132.ScrollDispatcher)) { return this._ScrollDispatcher_167; }
    if ((token === import133.ViewportRuler)) { return this._ViewportRuler_168; }
    if ((token === import73.OverlayPositionBuilder)) { return this._OverlayPositionBuilder_169; }
    if ((token === import74.Overlay)) { return this._Overlay_170; }
    if ((token === import75.ColorUtil)) { return this._ColorUtil_171; }
    if ((token === import76.DateLocale)) { return this._DateLocale_172; }
    if ((token === import77.DateUtil)) { return this._DateUtil_173; }
    if ((token === import32.Md2ToastConfig)) { return this._Md2ToastConfig_174; }
    if ((token === import32.Md2Toast)) { return this._Md2Toast_175; }
    if ((token === import78.Platform)) { return this._Platform_176; }
    if ((token === import79.InteractivityChecker)) { return this._InteractivityChecker_177; }
    if ((token === import80.FocusTrapFactory)) { return this._FocusTrapFactory_178; }
    if ((token === import134.LiveAnnouncer)) { return this._LiveAnnouncer_179; }
    if ((token === import135.FocusOriginMonitor)) { return this._FocusOriginMonitor_180; }
    if ((token === import5.OverlayContainer)) { return this._OverlayContainer_181; }
    if ((token === import5.ɵr)) { return this._ɵr_182; }
    if ((token === import5.Overlay)) { return this._Overlay_183; }
    if ((token === import5.UniqueSelectionDispatcher)) { return this._UniqueSelectionDispatcher_184; }
    if ((token === import5.InteractivityChecker)) { return this._InteractivityChecker_185; }
    if ((token === import5.FocusTrapFactory)) { return this._FocusTrapFactory_186; }
    if ((token === import5.LiveAnnouncer)) { return this._LiveAnnouncer_187; }
    if ((token === import5.MdDialog)) { return this._MdDialog_188; }
    if ((token === import5.MdDatepickerIntl)) { return this._MdDatepickerIntl_189; }
    if ((token === import5.MdIconRegistry)) { return this._MdIconRegistry_190; }
    if ((token === import5.MdSnackBar)) { return this._MdSnackBar_191; }
    if ((token === import5.ɵa)) { return this._ɵa_192; }
    if ((token === import81.AuthTokenGuard)) { return this._AuthTokenGuard_193; }
    if ((token === import82.NotificationsService)) { return this._NotificationsService_194; }
    if ((token === import40.PERFECT_SCROLLBAR_CONFIG)) { return this._PERFECT_SCROLLBAR_CONFIG_195; }
    if ((token === import159.PerfectScrollbarConfig)) { return this._PerfectScrollbarConfig_196; }
    if ((token === import83.WindowRef)) { return this._WindowRef_197; }
    if ((token === import83.DocumentRef)) { return this._DocumentRef_198; }
    if ((token === import84.LAZY_MAPS_API_CONFIG)) { return this._LAZY_MAPS_API_CONFIG_199; }
    if ((token === import161.MapsAPILoader)) { return this._MapsAPILoader_200; }
    if ((token === import6.ActivatedRoute)) { return this._ActivatedRoute_201; }
    if ((token === import6.NoPreloading)) { return this._NoPreloading_202; }
    if ((token === import6.PreloadingStrategy)) { return this._PreloadingStrategy_203; }
    if ((token === import6.RouterPreloader)) { return this._RouterPreloader_204; }
    if ((token === import6.PreloadAllModules)) { return this._PreloadAllModules_205; }
    if ((token === import6.ROUTER_INITIALIZER)) { return this._ROUTER_INITIALIZER_206; }
    if ((token === import0.APP_BOOTSTRAP_LISTENER)) { return this._APP_BOOTSTRAP_LISTENER_207; }
    if ((token === import3.DatePipe)) { return this._DatePipe_208; }
    if ((token === import85.RolePermission)) { return this._RolePermission_209; }
    if ((token === import86.LinkAuth)) { return this._LinkAuth_210; }
    if ((token === import87.UserNameService)) { return this._UserNameService_211; }
    if ((token === import88.AuthGuard)) { return this._AuthGuard_212; }
    if ((token === import89.VerifiedGuard)) { return this._VerifiedGuard_213; }
    if ((token === import90.NoAuthGuard)) { return this._NoAuthGuard_214; }
    if ((token === import86.LinkHelper)) { return this._LinkHelper_215; }
    if ((token === import91.NotificationServiceBus)) { return this._NotificationServiceBus_216; }
    if ((token === import92.SpinnerService)) { return this._SpinnerService_217; }
    if ((token === import162.AuthHttp)) { return this._AuthHttp_218; }
    if ((token === import93.PopupService)) { return this._PopupService_219; }
    if ((token === import94.BookingService)) { return this._BookingService_220; }
    if ((token === import95.UserService)) { return this._UserService_221; }
    if ((token === import96.PreferedAllocationService)) { return this._PreferedAllocationService_222; }
    if ((token === import97.BookingHeaderService)) { return this._BookingHeaderService_223; }
    if ((token === import98.GmapsApiService)) { return this._GmapsApiService_224; }
    if ((token === import99.MessagingService)) { return this._MessagingService_225; }
    if ((token === import100.BookingListMultiSelectService)) { return this._BookingListMultiSelectService_226; }
    if ((token === import101.SubOrganisationFilterService)) { return this._SubOrganisationFilterService_227; }
    return notFoundResult;
  }
  destroyInternal():void {
    this._ɵf_15.ngOnDestroy();
    (this.__ɵDomSharedStylesHost_147 && this._ɵDomSharedStylesHost_147.ngOnDestroy());
    (this.__RouterPreloader_204 && this._RouterPreloader_204.ngOnDestroy());
  }
}
export const AppModuleNgFactory:import0.NgModuleFactory<import1.AppModule> = new import0.NgModuleFactory<any>(AppModuleInjector,import1.AppModule);
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.module.ngfactory.ts